import { render, staticRenderFns } from "./aside-settings-svg.vue?vue&type=template&id=1fab3cce&scoped=true"
import script from "./aside-settings-svg.vue?vue&type=script&lang=js"
export * from "./aside-settings-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab3cce",
  null
  
)

export default component.exports